/**
* @Description:
* @Author: TSY
* @CreateDate: 2018/12/13 14:06
*/
<template>
  <div class="body">
    <div class="input-card">
      <h4>下属行政区查询</h4>
      <div class="input-item">
        <div class="input-item-prepend"><span class="input-item-text">省</span></div>
        <select id='province' style="width:100px" @change='search("province")' :disabled="loading"></select>
      </div>
      <div class="input-item" v-show="showCitySelect">
        <div class="input-item-prepend"><span class="input-item-text">市</span></div>
        <select id='city' style="width:100px" @change='search("city")' :disabled="loading"></select>
      </div>
      <div class="input-item">
        <div class="input-item-prepend"><span class="input-item-text">区</span></div>
        <select id='district' style="width:100px" @change='search("district")' :disabled="loading"></select>
      </div>
      <p>请选择文件下载方式</p>
      <div class="radio">
        <input type="radio" value="name" v-model="nameType">单文件【按地域名称命名】
      </div>
      <div class="radio">
        <input type="radio" value="code" v-model="nameType">单文件【按地域行政编码命名】
      </div>
      <div class="radio">
        <input type="radio" value="area" v-model="nameType">全国省市区县乡村名称和编码
      </div>
      <div class="input-item download" @click="download" :class="{ disabled: loading }">
        <span v-if="loading" class="spinner"></span>
        <span>{{ loading ? '加载中...' : downloadTips }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "streetDialog",
  props: {
    downloadTips: {
      type: String,
      default: '下载geoJson数据'
    },
    loading: {
      type: Boolean,
      default: false
    },
    showCitySelect: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      nameType: 'code'
    }
  },
  mounted() {

  },
  computed: {},
  methods: {
    search(area) {
      if (this.loading) return;
      this.$emit('change', area);
    },
    download() {
      if (this.loading) return;
      this.$emit('click', this.nameType)
    }
  }
}
</script>

<style lang="stylus" scoped>
.body
  width auto
  height auto

.input-card
  padding 15px
  width 280px
  background white
  border-radius 5px
  box-shadow 0 2px 10px rgba(0,0,0,0.2)

h4
  margin 0 0 15px 0
  font-size 16px
  font-weight bold
  color #333

.input-item
  display flex
  margin-bottom 10px

.input-item-prepend
  margin-right 5px

.input-item-text
  display inline-block
  padding 5px
  background #e9ecef
  border 1px solid #ced4da
  border-radius 4px
  font-size 14px
  white-space nowrap

select
  flex 1
  padding 5px
  border 1px solid #ced4da
  border-radius 4px
  font-size 14px

select:disabled
  background-color #f5f5f5
  cursor not-allowed
  opacity 0.6

p
  margin 10px 0 5px 0
  font-size 14px
  color #333

.radio
  margin 5px 0
  font-size 14px
  color #333

.radio input
  margin-right 5px

.download
  display flex
  justify-content center
  align-items center
  margin-top 15px
  padding 10px
  border 1px solid #ced4da
  border-radius 4px
  background-color #e9ecef
  color #495057
  text-align center
  cursor pointer
  font-size 14px
  position relative

.download span
  display flex
  align-items center
  gap 8px

.download:hover
  background-color #d3d9df

.download:active
  background-color #c8cfd6

.download.disabled
  background-color #f5f5f5
  cursor not-allowed
  opacity 0.6

.download.disabled:hover
  background-color #f5f5f5

.download.disabled:active
  background-color #f5f5f5

.spinner
  width 16px
  height 16px
  border 2px solid #495057
  border-top-color transparent
  border-radius 50%
  animation spin 0.8s linear infinite

@keyframes spin
  from
    transform rotate(0deg)
  to
    transform rotate(360deg)
</style>